import { render, staticRenderFns } from "./SingleSectionSchematic.vue?vue&type=template&id=925b2cb6&scoped=true&"
import script from "./SingleSectionSchematic.vue?vue&type=script&lang=ts&"
export * from "./SingleSectionSchematic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925b2cb6",
  null
  
)

export default component.exports